import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ReferralHandler = () => {
  const { referralCode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (referralCode) {
      // Save referral code to localStorage
      localStorage.setItem('refCode', referralCode);
      console.log('Referral code saved:', referralCode);
      
      // Redirect to home page
      navigate('/', { replace: true });
    }
  }, [referralCode, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'Akkurat LL',
      color: '#fff',
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2 style={{ color: '#C9F032', marginBottom: '1rem' }}>Processing referral...</h2>
        <p style={{ color: 'rgba(255, 255, 255, 0.8)' }}>Redirecting you to the home page...</p>
      </div>
    </div>
  );
};

export default ReferralHandler; 